/* global axios */

import ApiClient from './ApiClient';

class BulkActionsAPI extends ApiClient {
  constructor() {
    super('bulk_actions', { accountScoped: true });
  }

  // A conta ANTES de aplicar: quantas pessoas entram em fluxo por causa desta
  // etiqueta, e em quais. Sem fluxo afetado devolve nulo e a tela segue direto.
  flowImpact(data) {
    return axios.post(`${this.url}/flow_impact`, data);
  }
}

export default new BulkActionsAPI();
